import React, { useContext, useState } from "react";
import { S3_ENDPOINT, formatMonto, getValue } from "../../utils";
import InscriptionWeb from "../modal/web/InscriptionWeb";
import success from "../../assets/images/exito-2.png";
import parse from "html-react-parser";
import { Link } from "@reach/router";
import moment from "moment";
import {
  getAccess,
  getCapacity,
  getCourseLastAttempt,
  getPrice,
  getStartEndDate,
  isCompleted,
  isExamAccessExpired,
  isAccessExpired,
} from "../../utils/course";
import { CourseAccessesContext } from "../../context/CourseAccessesContext";

const SingleCourseCard = ({ mode, course, location, completed_courses }) => {
  const [showModal, setShowModal] = useState(false);

  const { course_accesses } = useContext(CourseAccessesContext);

  const access = getAccess({
    course_accesses: course_accesses?.filter(
      (access) => access.course_id === course.course_id,
    ),
  });
  const minPrice = getPrice(course);
  const capacity = getCapacity(course, location);
  const completed = isCompleted(course, completed_courses);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const getSrc = () => {
    return course.file && course.file !== null
      ? `${course.file.name}.${course.file.type}`
      : "";
  };

  const src = getSrc();

  const renderModal = () => {
    if (showModal) {
      return (
        <InscriptionWeb
          mode={mode}
          show={showModal}
          course={course}
          location={location}
          handleClose={handleClose}
        />
      );
    }
  };

  const renderDates = () => {
    if (access) {
      return renderDateString(
        access.start_date !== null ? access.start_date : access.createdAt,
        access.expiration_date,
      );
    }
    const { startDate, endDate } = getStartEndDate(course, location);
    if (startDate !== null && endDate !== null) {
      return renderDateString(startDate, endDate);
    }
  };

  const renderDateString = (startDate, endDate) => {
    const diff = moment(endDate).utc().diff(moment(startDate).utc(), "days");
    if (diff > 1 && !access) {
      return (
        <p className="mb-4">
          <i className="fa fa-calendar me-2"></i>
          {new Array(diff).fill(1).map((one, index) => (
            <span>
              {moment(startDate).utc().add(index, "days").format("D")}
              {index === diff - 2 ? " y " : index < diff - 1 ? ", " : ""}
            </span>
          ))}{" "}
          de
          {moment(endDate).utc().format("MMM YYYY")}
        </p>
      );
    }
    return (
      <p className="mb-4">
        <i className="fa fa-calendar-alt me-2 text-primary"></i>
        {moment(startDate).utc().format("DD MMM YYYY")} -{" "}
        {moment(endDate).utc().format("DD MMM YYYY")}
      </p>
    );
  };

  const renderExamExpiration = () => {
    if (!access) return null;
    // Only show once we're within 7 days before expiration, and while access is still valid
    const windowStart = moment.utc(access.expiration_date).subtract(7, "days");
    if (moment.utc().isBefore(windowStart)) return null;
    if (isAccessExpired(access)) return null;
    const examDeadline = moment
      .utc(access.expiration_date)
      .add(7, "days")
      .format("DD MMM YYYY");
    return (
      <div className="p-3 br-10 bg-light">
        <p className="small mb-0" style={{ opacity: 0.75 }}>
          <i className="fa fa-calendar-alt me-2 text-primary"></i>
          Límite para Subir Examen:
          <br />
          <b>{examDeadline}</b>
        </p>
      </div>
    );
  };

  const renderPrice = () => {
    if (minPrice && !access) {
      return (
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            padding: "20px 0",
          }}
          className="d-none bold bg-dark d-lg-block text-center text-white"
        >
          <span className="small fw-normal d-block">desde</span>
          <span className="h3 bold">${formatMonto(minPrice)} MXN</span>
        </div>
      );
    }
  };

  const renderButton = () => {
    if (access) {
      const expired = isAccessExpired(access);
      if (isAccessExpired(access)) {
        const expiredExamAccess = isExamAccessExpired(access);
        if (expiredExamAccess) {
          const lastAttempt = getCourseLastAttempt(course);
          if (lastAttempt && lastAttempt !== null) {
            if (lastAttempt.gradedAt !== null) {
              return (
                <Link
                  to={`/mytbm/attempt/${lastAttempt.attempt_id}`}
                  className="btn btn-accent my-3"
                >
                  Ver resultado de examen final
                </Link>
              );
            }
            if (lastAttempt.finishedAt !== null) {
              return (
                <Link
                  to={`/mytbm/attempt/${lastAttempt.attempt_id}`}
                  className="btn bg-primary text-white my-3"
                >
                  Ver examen final
                </Link>
              );
            }
            if (
              lastAttempt.finishedAt === null &&
              lastAttempt.requested_changes
            ) {
              return (
                <Link
                  to={`/mytbm/attempt/${lastAttempt.attempt_id}`}
                  className="btn bg-dark text-prfimary text-white my-3"
                >
                  Corregir examen final
                </Link>
              );
            }
          }
          if (!completed) {
            return (
              <button onClick={handleShow} className="btn btn-dark my-3">
                Acceso expirado
              </button>
            );
          }
        }
        // Access expired but within 7-day grace period for exam upload
        if (!expired) {
          return (
            <Link
              to={`/mytbm/course/${course.course_id}`}
              className="btn btn-primary text-white my-3"
            >
              Continuar
            </Link>
          );
        }
      }
      if (access.start_date !== null) {
        if (moment(access.start_date).utc().isAfter(moment().utc())) {
          return (
            <button className="btn btn-dark my-3" disabled={true}>
              Acceso a partir de{" "}
              {moment(access.start_date).utc().format("DD MMM YYYY")}
            </button>
          );
        }
      }
      if (!expired) {
        return (
          <Link
            to={`/mytbm/course/${course.course_id}`}
            className={`btn btn-primary text-white my-3`}
          >
            {course.completed_lessons.length === 0 ? "Empezar" : "Continuar"}
          </Link>
        );
      }
    }
    if (window.location.pathname.includes("mytbm") && !course.upcoming) {
      if (completed) {
        return null;
      }
      return (
        <Link to="/courses" className="btn btn-primary my-3">
          Inscríbete
        </Link>
      );
    }
    const upcoming = getValue(course, "upcoming", true);
    if (completed) {
      return null;
    }
    return (
      <button
        className="btn btn-primary my-3"
        disabled={capacity === 0 || upcoming}
        onClick={handleShow}
      >
        {upcoming ? "Coming soon" : "Inscríbete"}
      </button>
    );
  };

  const renderDescription = () => {
    if (!window.location.pathname.includes("mytbm")) {
      return (
        <div>
          {" "}
          <p className="my-4 small">{parse(course.short_description)}</p>
          <p className="my-4 small">{parse(course.description)}</p>
        </div>
      );
    }
  };

  const renderPriceBottom = () => {
    if (!access) {
      return (
        <div
          style={{
            position: "absolute",
            bottom: -30,
            left: 0,
            right: 0,
            padding: "20px 0",
          }}
          className="d-block bg-dark text-white d-lg-none text-center"
        >
          <span className="h3 bold">$ {formatMonto(minPrice)} MXN</span>
          <span className="small fw-normal d-block">
            planes de pago disponibles
          </span>
        </div>
      );
    }
  };

  const renderPrecondition = () => {
    if (completed) {
      const lastAttempt = getCourseLastAttempt(course);
      let attemptButton = null;

      if (lastAttempt && lastAttempt !== null) {
        if (lastAttempt.gradedAt !== null) {
          attemptButton = (
            <Link
              to={`/mytbm/attempt/${lastAttempt.attempt_id}`}
              className="btn btn-light    mt-3"
            >
              Ver resultado de examen final
            </Link>
          );
        } else if (lastAttempt.finishedAt !== null) {
          attemptButton = (
            <Link
              to={`/mytbm/attempt/${lastAttempt.attempt_id}`}
              className="btn btn-light    mt-3"
            >
              Ver examen final
            </Link>
          );
        } else if (
          lastAttempt.finishedAt === null &&
          lastAttempt.requested_changes
        ) {
          attemptButton = (
            <Link
              to={`/mytbm/attempt/${lastAttempt.attempt_id}`}
              className="btn btn-light    mt-3"
            >
              Corregir examen final
            </Link>
          );
        }
      }

      return (
        <div className="bg-accent border border-primary br-10 p-3 mb-3 rounded">
          <h4 className="h6 mb-2">¡Haz Completado Esta Certificacion!</h4>
          <p className="small mb-0">
            Puedes continuar consultando los videos durante la vigencia de tu
            acceso.
          </p>
          {attemptButton}
        </div>
      );
    }
    const prereqConfig = {
      2: {
        courses: ["Sculpt and Burn"],
        note: "Una vez finalizada la certificación de Sculpt and Burn, puedes continuar con Barre (no es necesario esperar tus resultados de SNB).",
      },
      3: {
        courses: ["Sculpt and Burn", "Barre"],
        note: "Puedes inscribirte sin esperar resultados previos.",
      },
      6: {
        courses: ["Sculpt and Burn", "Barre"],
        note: "Una vez finalizada la certificación de Sculpt and Burn, y Barre, puedes continuar con Block Burn Pilates (no es necesario esperar tus resultados de SNB y Barre).",
      },
    };

    const prereq = prereqConfig[course.course_id];
    if (prereq) {
      return (
        <div
          className="mb-3 p-3"
          style={{
            background: "#F2EEE8",
            border: "1.5px solid #6B3440",
            borderRadius: "8px",
          }}
        >
          <p
            className="mb-2"
            style={{
              fontSize: "0.7rem",
              letterSpacing: "0.1em",
              textTransform: "uppercase",
              color: "#6B3440",
              fontWeight: 600,
            }}
          >
            Requisito previo
          </p>
          <div className="d-flex flex-wrap gap-1 mb-2">
            {prereq.courses.map((name) => (
              <span
                key={name}
                className="badge"
                style={{
                  background: "#3A2D31",
                  color: "#F2EEE8",
                  fontWeight: 400,
                  fontSize: "0.75rem",
                  padding: "4px 10px",
                  borderRadius: "20px",
                }}
              >
                {name}
              </span>
            ))}
          </div>
          <p
            className="mb-0"
            style={{ fontSize: "0.75rem", color: "#3A2D31", opacity: 0.75 }}
          >
            {prereq.note}
          </p>
        </div>
      );
    }
  };

  return (
    <div
      className="d-flex align-items-stretch home-course flex-column flex-lg-row h-100 border-0 shadow position-relative overflow-hidden"
      style={{
        border: "1px solid #27272b",
        cursor: "pointer",
        borderRadius: "16px",
      }}
    >
      {completed && (
        <img
          alt="checkmark"
          src={success}
          style={{
            position: "absolute",
            right: "20px",
            maxWidth: 50,
            top: "20px",
          }}
        />
      )}
      <div
        className="image-section"
        style={{ position: "relative", flexShrink: 0, height: "220px" }}
      >
        <div
          style={{
            backgroundImage: `url(${S3_ENDPOINT}/${src})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            position: "absolute",
            inset: 0,
          }}
        ></div>
        {renderPrice()}
      </div>
      <div
        className="d-flex flex-column text-section p-3"
        style={{ flexGrow: 1 }}
      >
        <div className="container-fluid d-flex flex-column flex-grow-1">
          <div className="flex-grow-1">
            {mode === "live" ? (
              <img
                src="https://thebodymethod.s3.us-west-1.amazonaws.com/tbmcert-logo-negro.png"
                alt="logo"
                style={{
                  width: "400px",
                  maxWidth: "100%",
                  marginBottom: "6px",
                }}
              />
            ) : (
              <h3
                className="h2 francois mb-2"
                style={{
                  minHeight: "4.5rem",
                  display: "flex",
                  alignItems: "flex-start",
                }}
              >
                {course.name}
              </h3>
            )}
            <span
              className={`badge badge-pill bg-${
                mode === "on-demand" ? "primary text-white" : "accent text-dark"
              }`}
            >
              {mode === "live" ? "en vivo" : mode}
            </span>

            {renderDescription()}
            <div className="d-flex mt-3">{renderDates()}</div>
            {renderExamExpiration()}
            {renderPrecondition()}
          </div>
          <div className="mt-auto   ">{renderButton()}</div>
        </div>
      </div>
      {renderPriceBottom()}
      {renderModal()}
    </div>
  );
};

export default SingleCourseCard;
